









































































































































































































































































import Vue from "vue"
import { IParcelService, parcelService } from "@/model/service/parcel/parcel-service"
import { IShipnotifyService, shipnotifyService } from "@/model/service/shipnotify/shipnotify-service"
import { Parcel } from "@/model/entity/parcel/parcel"
import moment from "moment"
import { saveAs } from "file-saver"
import Datatable, { DatatableOptions, FilterContainer, IDatatable } from "@/components/datatable/Datatable.vue"
import { FieldDescription, FieldTypeEnum } from "@/model/entity/field-descriptor"
import { plainToClass } from "class-transformer"
import { DpdProduct } from "@/model/new-parcel-model/dpd-product/dpd-product"
import NewParcel from "@/pages/parcels/new-parcel/NewParcel.vue"
import { ParcelStatusEnum, parcelStatusEnumList } from "@/model/enum/parcel-status-enum.ts"
import { ParcelAdditionalStatusEnum, parcelAdditionalStatusEnumList } from "@/model/enum/parcel-additional-status-enum"
import { Filter } from "@/model/dto/filter"
import qz from "qz-tray"
import { ResolvedProductVariant, ParcelModelHelper } from "@/model/new-parcel-model/parcel-model-helper"
import { FilterOptionEnum, filterOptionList } from "@/model/util/filter-option/filter-option-enum"
import filterOptions from "@/model/util/filter-option/filter-option"
import { DpdProductVariant } from "@/model/new-parcel-model/dpd-product/dpd-product-variant"
import { ProductVariantSearch } from "@/model/new-parcel-model/dpd-product/product-variant-search"

interface ParcelListData {
  dpdProducts: DpdProduct[] | null
  productVariantSearch: ProductVariantSearch | null
  dpdVariants: DpdProductVariant[] | null
  parcelService: IParcelService
  shipnotifyService: IShipnotifyService
  options: DatatableOptions
  fields: FieldDescription[]
  selectedItems: Parcel[]
  dialogVisible: boolean
  selectedProduct: ResolvedProductVariant | null | undefined
  selectedParcel: Parcel | null
  filters: FilterContainer
  deletableSelectedParcels: Parcel[]
  printableSelectedParcels: Parcel[]
  selfbookableSelectedParcels: Parcel[]
  sendableSelectedParcels: Parcel[]
  cancellableSelectedParcels: Parcel[]
  parcelStatusEnumList: ParcelStatusEnum[]
  additionalParcelStatusEnumList: ParcelAdditionalStatusEnum[]
  filterOptionList: FilterOptionEnum[]
  option: FilterOptionEnum
  controlDisabled: boolean
}

export default Vue.extend({
  components: { Datatable, NewParcel },
  mixins: [filterOptions],
  data(): ParcelListData {
    return {
      dpdProducts: null,
      dpdVariants: null,
      productVariantSearch: new ProductVariantSearch(),
      options: {
        operations: {}
      },
      fields: Parcel.getFieldDescriptionList(),
      parcelService: parcelService,
      shipnotifyService: shipnotifyService,
      selectedItems: [],
      dialogVisible: false,
      selectedProduct: null,
      selectedParcel: null,
      option: filterOptionList[0],
      filterOptionList: filterOptionList,
      filters: {
        updateDate: [
          moment()
            .startOf("day")
            .toDate(),
          moment()
            .endOf("day")
            .toDate()
        ]
      },
      deletableSelectedParcels: [],
      printableSelectedParcels: [],
      selfbookableSelectedParcels: [],
      sendableSelectedParcels: [],
      cancellableSelectedParcels: [],
      parcelStatusEnumList: parcelStatusEnumList,
      additionalParcelStatusEnumList: parcelAdditionalStatusEnumList,
      controlDisabled: false
    }
  },
  methods: {
    getAdditionalStatus(codes: string) {
      if (notEmpty(codes)) {
        return codes
          .split(/[,;]/)
          .map(code => this.additionalParcelStatusEnumList.find(parcelStatus => parcelStatus.code === Number(code)))
      }
      return []
    },
    resolveRowClass(event: any) {
      if (event.row.parcelStatus === "CREATED") {
        return "parcel-created"
      } else if (event.row.parcelStatus === "PRINTED") {
        return "parcel-printed"
      } else if (event.row.parcelStatus === "CANCELLED") {
        return "parcel-cancelled"
      } else if (event.row.parcelStatus === "CANCELLED_SENT") {
        return "parcel-cancelled"
      } else if (event.row.parcelStatus === "PREPARED_TO_CANCEL") {
        return "parcel-cancelled"
      }
      return "parcel-default"
    },
    resolveCellStyle(event: any) {
      if (exists(event.column.property) && event.column.property === "statusId") {
        let color
        switch (event.row.parcelStatus) {
          case "CONSOLIDATION":
          case "OUT_FOR_DELIVERY":
          case "PICK_UP":
          case "WAREHOUSE":
          case "INBOUND_EXCEPTION":
          case "HUB_SCAN":
          case "CUSTOMS_CLEARANCE_PROCESS":
          case "DRIVERS_PICK_UP":
          case "EXPORT_IMPORT_CLEARED":
          case "ADDITIONAL_INFORMATION":
          case "LOADING":
            color = "yellow"
            break
          case "DRIVERS_RETURN":
          case "SYSTEM_RETURN":
          case "DELIVERY_ATTEMPT_NOT_SUCCESSFUL":
            color = "tomato"
            break
          case "DELIVERED":
          case "DELIVERED_BY_DRIVER_TO_DPD_PARCELSHOP":
            color = "lightgreen"
            break
          default:
            return ""
        }
        return "background-color: " + color
      }
    },
    onDialogClose() {
        const datatable = this.$refs.datatable as IDatatable
        datatable.refreshData()
    },
    filterChange(dates: Date[]) {
      if (exists(dates)) {
        dates[0] = moment(dates[0])
          .startOf("day")
          .toDate()
        dates[1] = moment(dates[1])
          .endOf("day")
          .toDate()
      }
      if (!exists(this.filters.updateDate)) {
        this.$set(this.filters, "updateDate", dates)
      } else {
        this.filters.updateDate = dates
      }
      const datatable = this.$refs.datatable as IDatatable
      datatable.refreshData()
    },
    async showDetails(parcel: Parcel) {
      const vm = this
      this.selectedParcel = parcel
      let dpdProduct = null
      const countryId = parcel.shipment.shipmentReceiver.country.id
      await this.$http.get("/product/all_products").then(res => {
        vm.dpdProducts = res.data
      })
      if (parcel.serviceCode === "332") {
        const parentParcel = await this.$http
          .get(`/parcel/parcel_number/${Number(parcel.parcelReference)}`)
          .then(response => {
            return response.data
          })
        await this.$http.get(`/product/product_variant/${parentParcel.serviceCode}/${parcel.serviceCode}`).then(res => {
          dpdProduct = vm.dpdProducts.find(obj => {
            return obj.type === res.data.productType
          })
        })
      } else {
        vm.productVariantSearch.serviceCode = Number(parcel.serviceCode)
        vm.productVariantSearch.asCode = parcel.asCode
        vm.productVariantSearch.serviceBackCode = Number(parcel.serviceBackCode)
        await this.$http
          .post(`/product/product_variant`, vm.productVariantSearch)
          .then(res => {
            dpdProduct = vm.dpdProducts.find(obj => {
              return obj.type === res.data.productType
            })
          })
      }
      await this.$http.get(`/product/employee_product_variant/${dpdProduct.type}/${countryId}`).then(res => {
        vm.dpdVariants = plainToClass(DpdProductVariant, res.data)
      })
      const parcelModelHelper = new ParcelModelHelper(vm.dpdVariants)
      vm.selectedProduct = parcelModelHelper.resolveProductVariant(parcel.serviceCode)
      vm.dialogVisible = true
    },
    printParcels(parcels: Parcel[]) {
      this.controlDisabled = true
      const vm = this
      const datatable = vm.$refs.datatable as IDatatable
      vm.startLoad()
      vm.parcelService
        .print(parcels.map(parcel => parcel.id!))
        .then(response => {
          vm.handleFileResponse(response)
          datatable.refreshData()
          this.controlDisabled = false
        })
        .catch(() => {
          this.controlDisabled = false
          vm.endLoad()
        })
    },
    deleteEntity(parcels: Parcel[]) {
      const vm = this
      const datatable = vm.$refs.datatable as IDatatable
      vm.startLoad()
      vm.parcelService
        .deleteParcelsById(parcels.map(parcel => parcel.id!))
        .then(response => {
          if (response.data.notDeletedParcels.length > 0) {
            vm.$message({
              message: vm.$t("parcels.parcel_list.delete_fail").toString(),
              type: "warning"
            })
          }
          datatable.clearSelection()
          datatable.refreshData()
        })
        .catch(() => {
          vm.endLoad()
        })
    },
    cancelEntity(parcels: Parcel[]) {
      const vm = this
      const datatable = vm.$refs.datatable as IDatatable
      vm.startLoad()
      vm.parcelService
        .cancelParcelsById(parcels.map(parcel => parcel.id!))
        .then(response => {
          if (response.data.notCancelledParcels.length > 0) {
            vm.$message({
              message: vm.$t("parcels.parcel_list.cancel_fail").toString(),
              type: "warning"
            })
          }
          datatable.clearSelection()
          datatable.refreshData()
        })
        .catch(() => {
          vm.endLoad()
        })
    },
    prepareToSend(parcels: Parcel[]) {
      const vm = this
      const datatable = vm.$refs.datatable as IDatatable
      vm.startLoad()
      vm.parcelService
        .prepareToSend(parcels.map(parcel => parcel.id!))
        .then(() => {
          vm.endLoad()
          datatable.refreshData()
        })
        .catch(() => {
          vm.endLoad()
        })
    },
    geodata(parcels: Parcel[]) {
      const vm = this
      const datatable = vm.$refs.datatable as IDatatable
      vm.startLoad()
      vm.shipnotifyService
        .geodata(parcels.map(parcel => parcel.id!))
        .then(response => {
          vm.handleFileResponse(response)
          vm.endLoad()
        })
        .catch(() => {
          vm.endLoad()
        })
    },
    createSelfBookingList(parcels: Parcel[]) {
      const vm = this
      vm.startLoad()
      vm.parcelService
        .createSelfBookingList(parcels.map(parcel => parcel.id!))
        .then(response => {
          vm.endLoad()
          vm.handleFileResponseNonZpl(response)
        })
        .catch(() => {
          vm.endLoad()
        })

      const codParcelIds = parcels
        .filter(parcel => exists(parcel.parcelCOD) && exists(parcel.parcelCOD!.amount))
        .map(parcel => parcel.id!)

      if (codParcelIds.length > 0) {
        vm.parcelService
          .createSelfBookingCodList(codParcelIds)
          .then(response => {
            vm.endLoad()
            vm.handleFileResponseNonZpl(response)
          })
          .catch(() => {
            vm.endLoad()
          })
      }
    },
    executeQz(call: () => void, response: any) {
      const vm = this
      if (qz.websocket.isActive()) {
        call()
      } else {
        qz.websocket
          .connect()
          .then(call)
          .catch((e: any) => {
            vm.$error(vm.$t("qz.error"))
            vm.handleFileResponseNonZpl(response)
          })
      }
    },
    handleFileResponseNonZpl(response: any) {
      const contentType = response.headers["content-type"]
      const blob = new Blob([response.data], { type: contentType })
      const filename = response.headers["content-disposition"].match(/attachment; filename=(.*)/)[1]
      saveAs(blob, filename)
    },
    handleFileResponse(response: any) {
      const vm = this
      const employee = this.$store.state.authenticatedEmployee
      if (
        (employee.office.reportPageFormat === "ZPL" || employee.office.reportPageFormat === "ZPL_300") &&
        employee.office.printingMethod === "MIDDLEWARE" &&
        notEmpty(employee.office.printer)
      ) {
        const data = new TextDecoder().decode(response.data)
        const config = qz.configs.create(employee.office.printer)
        const call = () =>
          qz
            .print(config, [data])
            .then()
            .catch((e: any) => vm.$error(vm.$t("qz.error")))
        this.executeQz(call, response)
      } else {
        this.handleFileResponseNonZpl(response)
      }
    },
    updateSelection() {
      this.deletableSelectedParcels = this.selectedItems.filter(parcel => parcel.deletable)
      this.printableSelectedParcels = this.selectedItems.filter(parcel => parcel.printable)
      this.selfbookableSelectedParcels = this.selectedItems.filter(parcel => parcel.selfBookable)
      this.sendableSelectedParcels = this.selectedItems.filter(parcel => parcel.sendable)
      this.cancellableSelectedParcels = this.selectedItems.filter(parcel => parcel.cancellable)
    },
    getStatusDate(date: any) {
      return moment(new Date(date)).format("DD.MM.YYYY HH:mm")
    },
    getStatusI18n(status: number) {
      const parcelStatusEnum = this.parcelStatusEnumList.find(parcelStatus => parcelStatus.value === status)
      if (exists(parcelStatusEnum)) {
        return parcelStatusEnum!.i18nKey
      }
      return this.parcelStatusEnumList.find(parcelStatus => parcelStatus.name === "UNKNOWN")!.i18nKey
    },
    toggleEmployeeFilter(value: boolean) {
      if (value) {
        if (!exists(this.filters.employee)) {
          this.$set(this.filters, "employee", this.$store.getters.loggedUser.username)
        } else {
          this.filters.employee = this.$store.getters.loggedUser.username
        }
      } else {
        this.filters.employee = ""
      }
      const datatable = this.$refs.datatable as IDatatable
      datatable.refreshData()
    },
    exportFile() {
      const vm = this
      vm.startLoad()
      const filters: Filter[] = []
      vm.fields
        .filter(field => exists(vm.filters[field.fieldName!]) && vm.filters[field.fieldName!].toString().length > 0)
        .forEach(field => {
          if (field.fieldType === FieldTypeEnum.DATE) {
            filters.push(new Filter(field.fieldName! + "From", vm.filters[field.fieldName!][0].getTime()))
            filters.push(new Filter(field.fieldName! + "To", vm.filters[field.fieldName!][1].getTime()))
          } else {
            filters.push(new Filter(field.fieldName!, vm.filters[field.fieldName!]))
          }
        })
      if (exists(vm.filters["company"]) && vm.filters["company"] !== "") {
        filters.push(new Filter("company", vm.filters["company"]))
      } else if (exists(vm.filters["office"]) && vm.filters["office"] !== "") {
        filters.push(new Filter("office", vm.filters["office"]))
      } else if (
        exists(vm.filters["employee"]) &&
        vm.filters["employee"] !== "" &&
        !exists(vm.fields[vm.fields.findIndex(f => f.fieldName === "employee")])
      ) {
        filters.push(new Filter("employee", vm.filters["employee"]))
      }
      this.parcelService
        .exportExcel(filters)
        .then((response: any) => {
          vm.endLoad()
          vm.handleFileResponseNonZpl(response)
        })
        .catch(() => vm.endLoad())
    },
    updateFilterOption(option: FilterOptionEnum) {
      switch (option.value) {
        case 1:
          this.$set(this.filters, "office", this.$store.getters.loggedUser.office.id)
          this.filters.employee = ""
          this.filters.company = ""
          break
        case 2:
          this.$set(this.filters, "employee", this.$store.getters.loggedUser.username)
          this.filters.office = ""
          this.filters.company = ""
          break
        case 3:
          this.$set(this.filters, "company", this.$store.getters.loggedUser.office.company.id)
          this.filters.office = ""
          this.filters.employee = ""
          break
      }
      const datatable = this.$refs.datatable as IDatatable
      datatable.refreshData()
    }
  },
  watch: {
    selectedItems: {
      deep: true,
      handler() {
        this.updateSelection()
      }
    }
  }
})
